
/**
 * @param {*} input
 */
export function toHtml(input)
{
    let value = input || '';

    if (value.startsWith('lexical:'))
    {
        const { html } = JSON.parse(value.substring(8));
        value = html;
    }

    if (value.startsWith('richtext:'))
    {
        const { value: richTextValue } = JSON.parse(value.substring(9));
        value = richTextValue;
    }

    return value;
}
